import { ActivityHeatmap } from '../ui/ActivityHeatmap.js';

interface ActivitySectionProps {
  data: { date: string; count: number }[];
}

export function ActivitySection({ data }: ActivitySectionProps) {
  return (
    <div className="rounded-xl border border-[var(--color-border)] bg-[var(--color-surface)] p-5">
      <h2 className="mb-4 text-sm font-semibold text-[var(--color-text)] uppercase tracking-wider">
        Actividad
      </h2>
      <ActivityHeatmap data={data} weeks={26} />
    </div>
  );
}
